import { render, staticRenderFns } from "./Alianza.vue?vue&type=template&id=2dbd8a39"
import script from "./Alianza.vue?vue&type=script&lang=js"
export * from "./Alianza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports